// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"badge-module__sr-only___sFngW","badge":"badge-module__badge___4uOxv","small":"badge-module__small___YTam+","elevated":"badge-module__elevated___w-jIl"};